var CookiePolicy = function () {
  var getCookie = function (name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    return parts.length === 2 ? parts.pop().split(';').shift() : "";
  }

  var getCookieDocument = function (clinicsHost, clinicsApiKey) {
    var legalXhr = new XMLHttpRequest();

    legalXhr.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var documents = JSON.parse(this.responseText);

        var docFilter = function (doc) {
          return doc.typeName === 'cookies' && doc.languageCode === 'cs' && doc.regionCode === 'CZ'
        }

        $("#cookie-policy-settings-holder-legal").html(documents.filter(docFilter)[0].content)
      }
    }

    legalXhr.open('GET', clinicsHost + "/api/v3/legal-documents?category=default&languageCode=cs");
    legalXhr.setRequestHeader('Content-Type', 'application/json');
    legalXhr.setRequestHeader('X-Api-Key', clinicsApiKey);
    legalXhr.send()
  }

  function getExpires(days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    return "expires=" + date.toUTCString();
  }

  function sendDataLayer(type) {
    window.dataLayer.push({'event': 'consentgranted', 'consent_type': type});
  }

  function setCookie(name, value, days) {
    document.cookie = name + "=" + value + ";" + getExpires(days) + ";path=/";
  }

  function getAcceptCookie(element) {
    if ($(element).attr('data-selected') === 'true') {
      return 'yes';
    }

    return 'no';
  }

  function confirmAllCookies() {
    var days = 365;
    setCookie('cookiePolicyConfirmed', 'true', days);
    setCookie('cookie-preference_analytics', 'yes', days);
    setCookie('cookie-preference_marketing', 'yes', days);
    setCookie('cookie-preference_performance', 'yes', days);
    setCookie('cookie-preference_technical', 'yes', days);

    sendDataLayer('analytics');
    sendDataLayer('marketing');
    sendDataLayer('performance');
    sendDataLayer('technical');
  }

  function confirmNecessaryCookies() {
    var days = 30;
    setCookie('cookiePolicyConfirmed', 'true', days);
    setCookie('cookie-preference_analytics', 'no', days);
    setCookie('cookie-preference_marketing', 'no', days);
    setCookie('cookie-preference_performance', 'no', days);
    setCookie('cookie-preference_technical', 'yes', days);

    sendDataLayer('technical');
  }

  function confirmSelectedCookies() {
    var days = 30;
    setCookie('cookiePolicyConfirmed', 'true', days);
    setCookie('cookie-preference_analytics', getAcceptCookie('#accept-analytics-cookie'), days);
    setCookie('cookie-preference_marketing', getAcceptCookie('#accept-marketing-cookie'), days);
    setCookie('cookie-preference_performance', getAcceptCookie('#accept-performance-cookie'), days);
    setCookie('cookie-preference_technical', 'yes', days);

    sendDataLayer('technical');
    if (getAcceptCookie('#accept-analytics-cookie') === 'yes') sendDataLayer('analytics');
    if (getAcceptCookie('#accept-marketing-cookie') === 'yes') sendDataLayer('marketing');
    if (getAcceptCookie('#accept-performance-cookie') === 'yes') sendDataLayer('performance');
  }

  var cookiePolicy = function () {
    $(document).ready(function () {
      $('#cookie-policy-all').click(function (event) {
        $('#cookie-policy-basic-holder').hide();
        $('#cookie-policy-settings-holder').hide();
        $('#cookie-policy-backdrop').hide();

        confirmAllCookies();
      });

      $('#cookie-policy-none').click(function (event) {
        $('#cookie-policy-basic-holder').hide();
        $('#cookie-policy-settings-holder').hide();
        $('#cookie-policy-backdrop').hide();

        confirmNecessaryCookies();
      });

      $('#cookie-policy-settings-save').click(function (event) {
        $('#cookie-policy-basic-holder').hide();
        $('#cookie-policy-settings-holder').hide();
        $('#cookie-policy-backdrop').hide();

        confirmSelectedCookies();
      });

      $('#cookie-policy-settings-all').click(function (event) {
        $('#cookie-policy-basic-holder').hide();
        $('#cookie-policy-settings-holder').hide();
        $('#cookie-policy-backdrop').hide();

        confirmAllCookies();
      });

      $('#cookie-policy-settings').click(function (event) {
        $('#cookie-policy-basic-holder').hide();
        $('#cookie-policy-backdrop').show()
        $('#cookie-policy-settings-holder').show();
      });

      $('.cookie-policy-settings-option-header').click(function (event) {
        var parent = $(event.currentTarget).parent();
        var which = $(parent).data('which');
        var options = $('.cookie-policy-settings-option').each(function (index, element) {
          var currentWhich = $(element).data('which');
          var currentChevron = $(element).find('.cookie-policy-settings-option-chevron');
          var description = $(element).find('.cookie-policy-settings-option-description');
          if (currentWhich === which) {
            var isVisible = $(description).attr('data-visible');
            if (isVisible === 'true') {
              $(description).attr('data-visible', false);
              $(currentChevron).removeClass('description-open');
            } else {
              $(description).attr('data-visible', true);
              $(currentChevron).addClass('description-open');
            }
          } else {
            $(description).attr('data-visible', false);
            $(currentChevron).removeClass('description-open');
          }
        })
        var description = $(parent).find();
      });

      $('.cookie-policy-settings-option-buttons[data-disabled=false] .cookie-policy-settings-option-btn[data-value=false]').click(function (event) {
        event.stopPropagation();
        var clickedButton = $(event.currentTarget);
        var theOtherButton = $(clickedButton.siblings()[0]);

        if (clickedButton.attr('data-selected') === 'false') {
          theOtherButton.attr('data-selected', false);
          clickedButton.attr('data-selected', true);
        }
      });

      $('.cookie-policy-settings-option-buttons[data-disabled=false] .cookie-policy-settings-option-btn[data-value=true]').click(function (event) {
        event.stopPropagation();
        var clickedButton = $(event.currentTarget);
        var theOtherButton = $(clickedButton.siblings()[0]);

        if (clickedButton.attr('data-selected') === 'false') {
          theOtherButton.attr('data-selected', false);
          clickedButton.attr('data-selected', true);
        }
      });

      $('#cookie-policy-settings-holder-legal-link').click(function () {
        $('#cookie-policy-settings-title-content').hide();
        $('#cookie-policy-settings-title-legal').show();
        $('#cookie-policy-settings-holder-content').hide();
        $('#cookie-policy-settings-holder-legal').show();
        $('.cookie-policy-settings-title-arrow').show();
        $('.cookie-policy-settings-title').addClass('cookie-policy-settings-title-legal');
        $('.cookie-policy-settings-actions').hide();
      })

      $('#cookie-policy-settings-title-arrow').click(function () {
        $('#cookie-policy-settings-title-content').show();
        $('#cookie-policy-settings-title-legal').hide();
        $('#cookie-policy-settings-holder-content').show();
        $('#cookie-policy-settings-holder-legal').hide();
        $('.cookie-policy-settings-title-arrow').hide();
        $('.cookie-policy-settings-title').removeClass('cookie-policy-settings-title-legal');
        $('.cookie-policy-settings-actions').show();
      })

    });
  };

  var init = function () {
    cookiePolicy();
  };

  return {
    init: init,
    getCookie: getCookie,
    getCookieDocument: getCookieDocument
  };
}();

UL.register(CookiePolicy);
